import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  vi: {
    "取消": 'Hủy bỏ',
    "确定": 'Lưu lại',
    "发送": 'Gửi',
    "系统通知": 'Thông báo hệ thống',
    "关闭": 'Đóng',
    "图片": 'Hình ảnh',
    "文件": 'Tệp',
    "表情": 'biểu tượng cảm xúc',
    "视频": 'video',
    "录制": 'Ghi hình',
    "拍照": 'Chụp ảnh',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
